module.exports = __webpack_public_path__ + "img/1.baa02cfe.svg";